import {
    ChangeNotificationCustomerErrorPayLoad,
    ChangeNotificationCustomerRequestPayload,
    deleteCustomerErrorPayLoad,
    getCallTransferCustomerLineByCustomerMemberErrorPayLoad,
    getCallTransferCustomerLineByCustomerMemberSuccessPayload,
    getCallTransferCustomerQueueByErrorPayLoad,
    getCallTransferCustomerQueueBySuccessPayload,
    InsertCustomerErrorPayLoad,
    InsertCustomerRequestPayload,
    InsertCustomerSuccessPayload,
    UpdateCustomerErrorPayLoad,
    UpdateCustomerRequestPayload,
    UpdateCustomerSuccessPayload
}
    from "../interfaces/customer"

import {
    ChangeNotificationCustomerError,
    ChangeNotificationCustomerRequest,
    ChangeNotificationCustomerSuccess,
    DeleteCustomerError,
    DeleteCustomerRequest,
    DeleteCustomerSuccess,
    getCallTransferCustomerLineByCustomerMemberError,
    getCallTransferCustomerLineByCustomerMemberRequest,
    getCallTransferCustomerLineByCustomerMemberSuccess,
    InsertCustomerError,
    InsertCustomerRequest,
    InsertCustomerSuccess,
    resetActionRequest,
    resetUpdateAndInsertRequest,
    UpdateCustomerError,
    UpdateCustomerRequest,
    UpdateCustomerSuccess,
    resetDeleteRequest,
    getCallTransferQueueByCustomerRequest,
    getCallTransferQueueByCustomerSuccess,
    getCallTransferQueueByCustomerError,
    resetGetQueueByCustomerId,
    resetGetLineByCustomerId
}
    from "../types/customer/actionType"

import { Types } from "../types"


//insert********************************************************************************************************
export const insertCustomerRequestAction = (payload: InsertCustomerRequestPayload): InsertCustomerRequest => ({
    type: Types.INSERT_CUSTOMER_REQUEST,
    payload
})

export const insertCustomerSuccessAction = (payload: InsertCustomerSuccessPayload): InsertCustomerSuccess => ({
    type: Types.INSERT_CUSTOMER_SUCCESS,
    payload
})

export const insertCustomerErrorAction = (payload: InsertCustomerErrorPayLoad): InsertCustomerError => ({
    type: Types.INSERT_CUSTOMER_ERROR,
    payload
})

//delete**********************************************************************************************************
export const deleteCustomerRequestAction = (payload: string): DeleteCustomerRequest => ({
    type: Types.DELETE_CUSTOMER_REQUEST,
    payload
})

export const deleteCustomerSuccessAction = (): DeleteCustomerSuccess => ({
    type: Types.DELETE_CUSTOMER_SUCCESS,
})

export const deleteCustomerErrorAction = (payload: deleteCustomerErrorPayLoad): DeleteCustomerError => ({
    type: Types.DELETE_CUSTOMER_ERROR,
    payload
})
//Update**********************************************************************************************************
export const updateCustomerRequestAction = (payload: UpdateCustomerRequestPayload): UpdateCustomerRequest => ({
    type: Types.UPDATE_CUSTOMER_REQUEST,
    payload
})

export const updateCustomerSuccessAction = (payload: UpdateCustomerSuccessPayload): UpdateCustomerSuccess => ({
    type: Types.UPDATE_CUSTOMER_SUCCESS,
    payload
})

export const updateCustomerErrorAction = (payload: UpdateCustomerErrorPayLoad): UpdateCustomerError => ({
    type: Types.UPDATE_CUSTOMER_ERROR,
    payload
})
//Change notification**********************************************************************************************
export const changeNotificationCustomerRequestAction = (payload: ChangeNotificationCustomerRequestPayload): ChangeNotificationCustomerRequest => ({
    type: Types.CHANGE_MEMBER_NOTIFICATION_REQUEST,
    payload
})

export const changeNotificationCustomerSuccessAction = (): ChangeNotificationCustomerSuccess => ({
    type: Types.CHANGE_MEMBER_NOTIFICATION_SUCCESS

})

export const changeNotificationCustomerErrorAction = (payload: ChangeNotificationCustomerErrorPayLoad): ChangeNotificationCustomerError => ({
    type: Types.CHANGE_MEMBER_NOTIFICATION_ERROR,
    payload
})
//get line id by customer id****************************************************************************************
export const getCallTransferCustomerLineByCustomerMemberRequestAction = (payload: string): getCallTransferCustomerLineByCustomerMemberRequest => ({
    type: Types.GET_LINE_ID_BY_CUSTOMER_ID_REQUEST,
    payload
})

export const getCallTransferCustomerLineByCustomerMemberSuccessAction = (payload: getCallTransferCustomerLineByCustomerMemberSuccessPayload): getCallTransferCustomerLineByCustomerMemberSuccess => ({
    type: Types.GET_LINE_ID_BY_CUSTOMER_ID_SUCCESS,
    payload
})

export const getCallTransferCustomerLineByCustomerMemberErrorAction = (payload: getCallTransferCustomerLineByCustomerMemberErrorPayLoad): getCallTransferCustomerLineByCustomerMemberError => ({
    type: Types.GET_LINE_ID_BY_CUSTOMER_ID_ERROR,
    payload
})
// get queue by customer id****************************************************************************************
export const getCallTransferQueueByCustomerRequestAction = (payload: string): getCallTransferQueueByCustomerRequest => ({
    type: Types.GET_QUEUE_BY_CUSTOMER_ID_REQUEST,
    payload
})

export const getCallTransferQueueByCustomerSuccessAction = (payload: getCallTransferCustomerQueueBySuccessPayload): getCallTransferQueueByCustomerSuccess => ({
    type: Types.GET_QUEUE_BY_CUSTOMER_ID_SUCCESS,
    payload
})

export const getCallTransferQueueByCustomerErrorAction = (payload: getCallTransferCustomerQueueByErrorPayLoad): getCallTransferQueueByCustomerError => ({
    type: Types.GET_QUEUE_BY_CUSTOMER_ID_ERROR,
    payload
})
//reset************************************************************************************************************
export const resetAction = (): resetActionRequest => ({
    type: Types.RESET_CUSTOMER_LINE_ID_BY_CUSTOMER_ID_REQUEST,
})

export const resetUpdateAndInsertAction = (): resetUpdateAndInsertRequest => ({
    type: Types.RESET_CUSTOMER_INSERT_UPDATE,
})

export const resetDeleteAction = (): resetDeleteRequest => ({
    type: Types.RESET_CUSTOMER_DELETE,
})

export const resetDeleteCallQueueCustomerAction = (): resetGetQueueByCustomerId => ({
    type: Types.RESET_GET_QUEUE_BY_CUSTOMER_ID,
})

export const resetGetLineByCustomerIdAction = (): resetGetLineByCustomerId => ({
    type: Types.RESET_GET_LINE_BY_CUSTOMER_ID,
})





